// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nN9l","left":"styles_left__3tOlB"};